export const MODALCOLLABORATIONSTEPCOUNT = 2;
